import {
  ChartPropertiesOverrides,
  ChartingLibraryFeatureset,
} from './external/charting_library';

// var(--elevation-light)
const backgroundColor = '#0D111D';

export function getChartOverrides(
  _nightMode: boolean
): Partial<ChartPropertiesOverrides> {
  // https://github.com/tradingview/charting_library/wiki/Overrides
  // https://github.com/tradingview/charting_library/wiki/Drawings-Overrides
  return {
    // heikin ashi default
    // 'mainSeriesProperties.style': 8,
    // editorFontsList: ['sans-serif'],

    // 'scalesProperties.textColor',
    'paneProperties.background': backgroundColor,
    'paneProperties.backgroundGradientStartColor': backgroundColor,
    'paneProperties.backgroundGradientEndColor': backgroundColor,
    'paneProperties.separatorColor': '#393939',
    // 'paneProperties.backgroundType': 'gradient',
    'scalesProperties.axisLineToolLabelBackgroundColorActive': backgroundColor,

    // ??? 'paneProperties.vertGridProperties.style': '2',
    'paneProperties.vertGridProperties.color': '#18191d',
    'paneProperties.horzGridProperties.color': '#18191d',

    // 'paneProperties.topMargin': '20',
    // Min 3% to prevent price being cut on USD flat market chart
    // ??? 'paneProperties.bottomMargin': '3',

    // 'ChartDrawingToolbarWidget.visible': false,

    'scalesProperties.textColor': '#a1a1a1', // '#AAA',
    // 'scalesProperties.backgroundColor': 'red',

    // 'timeScale.rightOffset': 5,
    // 'paneProperties.rightMargin': 5,

    // https://github.com/tradingview/charting_library/wiki/Widget-Constructor#settings_adapter
    // Override symbolWatermarkProperties is not supported anymore. You can use settings_adapter with symbolWatermark key.
    // 'symbolWatermarkProperties.color': '#000000', // rgba(100, 100, 100, 0.15)',

    // Candles bars
    'mainSeriesProperties.candleStyle.upColor': '#00bc8a',
    'mainSeriesProperties.candleStyle.downColor': '#ee3f3f',
    // ??? 'mainSeriesProperties.candleStyle.drawWick': 'true',
    // ??? 'mainSeriesProperties.candleStyle.drawBorder': 'false',
    'mainSeriesProperties.candleStyle.borderColor': 'silver',
    'mainSeriesProperties.candleStyle.borderUpColor': '#00bc8a',
    'mainSeriesProperties.candleStyle.borderDownColor': '#ee3f3f',
    'mainSeriesProperties.candleStyle.wickUpColor': '#05684f',
    'mainSeriesProperties.candleStyle.wickDownColor': '#6c0a00',
    // ??? 'mainSeriesProperties.candleStyle.barColorsOnPrevClose': 'false',

    // ??? 'mainSeriesProperties.statusViewStyle.showExchange': 'false',
    // ??? 'mainSeriesProperties.statusViewStyle.showInterval': 'false',
    // ??? 'mainSeriesProperties.statusViewStyle.symbolTextSource': 'false',

    // Session breaks are not picked up by the chart
    // 'graphics.vertlines.sessBreaks.color': '#2a2e39',
    // 'graphics.vertlines.sessBreaks.style': '2',
    // 'graphics.vertlines.sessBreaks.visible': 'true',
    // 'graphics.vertlines.sessBreaks.width': '1',

    // 'Chart.ShowMarketOpenStatus': false,
  };
  // : {
  //     // 'mainSeriesProperties.style': 8,
  //     'paneProperties.background': '#FFFFFF',
  //     'paneProperties.vertGridProperties.color': '#E6E6E6',
  //     'paneProperties.horzGridProperties.color': '#E6E6E6',
  //     'scalesProperties.textColor': '#555',
  //     'symbolWatermarkProperties.color': 'rgba(100, 100, 100, 0.05)',
  //   };
}

export const getChartDisabledFeatures = (
  isMobile: boolean
): ChartingLibraryFeatureset[] =>
  isMobile
    ? [
        // 'use_localstorage_for_settings',
        'save_chart_properties_to_local_storage',
        // Must be disabled as we didn't implement "saveLineToolsAndGroups" in save adapter
        'saveload_separate_drawings_storage',
        'volume_force_overlay',
        'left_toolbar',
        // 'header_widget',
        'header_symbol_search',
        'header_indicators',
        'header_compare',
        'header_settings',

        // ??? 'widget_logo',
        // 'border_around_the_chart',

        'edit_buttons_in_legend',

        // ??? 'chart_property_page_timezone_sessions',
        'timeframes_toolbar',
        'display_market_status',
      ]
    : [
        // 'use_localstorage_for_settings',
        'save_chart_properties_to_local_storage',
        'volume_force_overlay',
        'header_symbol_search',
        // 'widget_logo', we can hide TradingView logo by this, needs discuss with TradingView wirst
        'display_market_status',
      ];

export const getChartEnabledFeatures = (
  isMobile: boolean
): ChartingLibraryFeatureset[] => {
  const defaultFeatures: ChartingLibraryFeatureset[] = [
    'hide_left_toolbar_by_default',
  ];
  // https://github.com/tradingview/charting_library/issues/7404
  if (isMobile && window?.ethereum?.isMetaMask) {
    return [...defaultFeatures, 'iframe_loading_compatibility_mode'];
  }
  return defaultFeatures;
  // If we need wider support, we can use below approach
  // const browserName = parseCurrentUserAgent().browser.name;
  // if (
  //   ['Chrome','Chromium','DuckDuckGo', 'Edge', 'Mozilla', 'Opera', 'Safari']
  //  .some(name => browserName?.includes(name))) {
  //   // Major browsers which should be compatible
  //   return defaultFeatures;
  // }
  // // https://github.com/tradingview/charting_library/issues/7296
  // // Unknown browsers could be incompatible
  // // eg. MetaMask browser, Trust, etc
  // console.log('[chartSettings] Fallback to compatibility mode');
  // return [...defaultFeatures, 'iframe_loading_compatibility_mode'];
};
